var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7699 14.0934C31.604 12.4778 31.2472 10.6918 29.9337 9.75328C28.9165 9.02544 27.5793 8.99856 26.331 9.00005C23.6923 9.00154 21.0521 9.00452 18.4133 9.00602C15.8753 9.00901 13.3372 9.01051 10.7992 9.0135C9.73898 9.01499 8.70836 8.93129 7.72364 9.39459C6.87812 9.79213 6.21622 10.5484 5.81789 11.3898C5.26556 12.56 5.15007 13.8856 5.08343 15.1799C4.96053 17.5367 4.97386 19.8996 5.12045 22.2549C5.22855 23.9736 5.50249 25.8732 6.81889 26.9687C7.98574 27.9386 9.63236 27.9864 11.1457 27.9879C15.9493 27.9924 20.7544 27.9969 25.5595 27.9999C26.1755 28.0014 26.8182 27.9894 27.446 27.9207C28.681 27.7862 29.8582 27.429 30.6519 26.5054C31.453 25.5743 31.6588 24.2785 31.7803 23.0515C32.0764 20.0744 32.0734 17.069 31.7699 14.0934ZM15.6354 22.6734V14.3265L22.7964 18.4992L15.6354 22.6734Z",
    fill: "#100A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f0807c8b04c253e3e75d46b4de7d6f86.svg";
export { ForwardRef as ReactComponent };